import { EmailAccountModel } from "@jugl-web/rest-api";

export const getEmailAccountDisplayEmail = (
  account: EmailAccountModel
): string => {
  if (account.type === "raw" && account.metadata?.client_email) {
    return account.metadata.client_email;
  }

  return account.email;
};
